import { InboxActions } from 'helpers/actions/inbox';
import { ViewStatisticsActions } from 'helpers/actions/view-statistics';
import { JobActions } from 'helpers/actions/job';
import { FirmActions } from 'helpers/actions/firm';
import { Role } from 'helpers/user';
import { historySetGridInitialParams } from 'helpers/grid-history';
import { ROUTE } from 'constants/route';

export const action = {
  inbox: {
    markAsRead: (api, { message, isOpen }, { grid }) => {
      const action = new InboxActions(api);
      action.markAsRead(api, { message, isOpen }, { grid });
    },

    remove: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.remove(api, { message }, { grid });
    },

    restore: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.restore(api, { message }, { grid });
    },

    removePermanently: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.removePermanently(api, { message }, { grid });
    },

    reply: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.reply(api, message, { grid });
    },

    forward: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.forward(api, message, { grid });
    },

    resumeAccept: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.resumeAccept(api, { message }, { grid });
    },

    resumeReject: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.resumeReject(api, { message }, { grid });
    },

    connectAccept: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.connectAccept(api, { message }, { grid });
    },

    connectReject: (api, { message }, { grid }) => {
      const action = new InboxActions(api);
      action.connectReject(api, { message }, { grid });
    },
  },

  job: {
    viewStatistics: (api, history, user, { job }) => {
      const action = new ViewStatisticsActions(api, history, user);
      action.job(job.ProcessID);
    },

    apply: (api, history, user, { job }, { grid }) => {
      const action = new JobActions(api, history, user);

      return action.apply(job).then(
        success =>
          success &&
          grid.actions.setDataRows(
            grid.data.rows.map(row =>
              row.ProcessID === job.ProcessID
                ? {
                    ...row,
                    ApplicationProcessID: true,
                  }
                : row
            )
          )
      );
    },

    checkApply: (api, history, user, { job }, { updateUserResume }) => {
      const action = new JobActions(api, history, user);
      return action.checkingApply(job, updateUserResume);
    },
  },

  firm: {
    setRating: (api, user, { id, mark }, { grid }) => {
      const action = new FirmActions(api, user);
      action.setRating({ id, mark }).then(data => {
        if (data) {
          grid.actions.setDataRows(
            grid.data.rows.map(row =>
              row.FirmID === id
                ? { ...row, ...data, CandidateRating: true }
                : row
            )
          );
        }
      });
    },

    beforeSetRating: (api, user) => {
      const action = new FirmActions(api, user);
      return action.checkRatingUpdate(user);
    },

    clickEmployeeLink: (history, user, { firmName }) => {
      if (Role.isCandidate(user, true)) {
        historySetGridInitialParams(history, ROUTE.NETWORK, {
          search: firmName,
        });
      }
    },
  },
};
